import styled from 'styled-components';
import { zBanners } from '~/styled';

export const OFFLINE_BANNER_HEIGHT = 40;

export const Banner = styled.div`
  width: 100%;
  height: ${OFFLINE_BANNER_HEIGHT}px;
  position: sticky;
  z-index: ${() => zBanners};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey700};
  background-color: ${({ theme }) => theme.colors.yellow500};
`;
